module.exports = __webpack_public_path__ + "img/pr.4d8fc765.jpg";